import { useEffect } from "react"

// Add global type declarations for window properties
declare global {
    interface Window {
        KampyleSurvey?: {
            showForm?: () => void;
        };
        Medallia?: ((action: string) => void);
    }
}

export const MedalliaSurvey = () => {
    useEffect(() => {
        // const scriptId = "medallia-survey-script";
        // if (document.getElementById(scriptId)) return;

        // const script = document.createElement("script");
        // script.id = scriptId;
        // script.src = "https://nebula-cdn.kampyle.com/eu/we/1109520/onsite/embed.js";
        // script.async = true;
        // document.body.appendChild(script);

        // script.onload = () => {
            // Intenta abrir el survey si la librería lo expone
            // if (window.KampyleSurvey) {
            //     window.KampyleSurvey.showForm && window.KampyleSurvey.showForm();
            // } else if (window.Medallia) {
            //     window.Medallia('show');
            // }
        // };

        // return () => {
        //     const existingScript = document.getElementById(scriptId);
        //     if (existingScript) {
        //         existingScript.remove();
        //     }
        // };
    }, []);

    return null;

}